export class Entrevista {
  public Id: number;
  public Descricao: string;
  public Ativo: boolean;

  // public Perguntas: EntrevistaPergunta[];
  public Grupos: EntrevistaGrupo[];

  constructor() {
    this.Id = 0;
    this.Descricao = '';
    this.Grupos = [];
    this.Ativo = true;
  }
}
export class EntrevistaPergunta {
  public Id: number;
  public EntrevistaId: number;
  public Pergunta: string;
  public Tipo: string;
  public EntrevistaGrupoId: number;
  public Ordem: number;
  public Deletado: boolean;
  public Resposta: string;
}
export class EntrevistaResposta {
  public Id: number;
  public EntrevistaId: number;
  public EntrevistaPerguntaId: number;
  public Tipo: string;
  public Resposta: string;
}

export class EntrevistaGrupo {
  public Id: number;
  public EntrevistaId: number;
  public Descricao: string;
  public Ordem: number;
  public Deletado: boolean;
  public Perguntas: EntrevistaPergunta[];
  public Resposta: EntrevistaPergunta[];
  constructor() {
    this.Perguntas = [];
    this.Resposta = [];
  }
}
